/*!

=========================================================
* Black Dashboard React v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import MapAddresse from "../home/mapAdresse" 
import NewsLetter from "../home/newsLetter"
import Footer from "../home/footer"
import SideList from "./../home/SideList";
import Popup from "reactjs-popup";
import BurgerIcon from "../home/BurgerIcon";
import Menu from "../home/Menu";
import object_background from "../assets/carriere/object_background.png";
import "./style/contact.css";
import { Grid, Row, Col } from "react-flexbox-grid";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {  UncontrolledAlert,Alert} from 'reactstrap';
 import axios from 'axios';
// reactstrap components
import {
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Label,
   
} from "reactstrap";
import thunk from "redux-thunk";
import NotificationAlert from 'react-notification-alert';

const contentStyle = {
    position: "relative",
    background: "linear-gradient(to right, #0c0abe , #07054c)", 
    border: "none",
    width: "100%",
    textAlign: "center",
    padding: "0px !important",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "80px",
    paddingBottom: "100%"
  
  };

class PostulateFormIntern extends React.Component {
   
    constructor(props) {
        super(props);
        
        this.onChangeFirstname = this.onChangeFirstname.bind(this);
        this.onChangeLastname = this.onChangeLastname.bind(this);
        this.onChangeNumber = this.onChangeNumber.bind(this);
        this.onchangeEmail=this.onchangeEmail.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    
    
        this.state = {
          show :false,
          post:'',
          cv:null,
          firstname: '',
          lastName: '',
          number: 0,
          email:'',
          internship_Offer:'',
          type_offer:'internship',
         
          ID:''
          
          
        }
      }
    
      componentDidMount() {
        axios.get(`${process.env.REACT_APP_SERVER}`+'/InternShip_Offer/'+this.props.match.params.id)
          .then(response => {
            this.setState({
              POst:response.data.Post,
              Id: response.data._id
              
            })   
         })
          .catch(function (error) {
            console.log(error);
          })
    
      }
      
    
      onchangeCV = event => {
        this.setState({
         cv: event.target.files[0]
        })
      }
      onChangeFirstname(e) {
        this.setState({
          firstname: e.target.value
        })
      }
      onChangeLastname(e) {
        this.setState({
          lastname: e.target.value
        })
      }
    
      onChangeNumber(e) {
        this.setState({
          number: e.target.value
        })
      }
    
      onchangeEmail(e) {
        this.setState({
          email: e.target.value
        })
      }
     
     
   
      onSubmit(e) {
        e.preventDefault();
    
        let form_data = new FormData();
        form_data.append('Firstname', this.state.firstname);
        form_data.append('Lastname', this.state.lastname);
        form_data.append('Cv', this.state.cv);
        form_data.append('Email', this.state.email);
        form_data.append('InternShip_Offer', this.state.Id);
        form_data.append('Number', this.state.number);
        form_data.append('Post_name', this.state.POst);
        form_data.append('Type_Offer', this.state.type_offer);
        const headers = {
          'Content-Type': 'multipart/form-data'
        }
        axios.post(`${process.env.REACT_APP_SERVER}`+'/Candidates/add', form_data,{
            headers:[headers]
          })       
          .then(res => {
            this.setState({isCliked : !this.state.isCliked ,
              show :!this.state.show })
              window.location="/carrieres";
          })
          .catch((error) => {
            console.log(error);
          })
         
      }
  render() {
    return (

        <div><div className="banniereSlidCarriere">
        {/*Menu horizontal Web*/}
        <div className="menu-horizontal">
            <Menu />
        </div>
        {/*Menu Responsive Popup*/}
        <div className="menuMobile">
            <Popup
                modal
                overlayStyle={{  background: "linear-gradient(to right, #0c0abe , #07054c)",  width: "100%" }}
                contentStyle={contentStyle}
                closeOnDocumentClick={false}
                trigger={open => <BurgerIcon open={open} />}
            >
            <SideList />
            </Popup>
        </div>
        <div className="textBanniereCarriere">
                 
                        <h1 className="sliderTitleCarriere">REJOIGNEZ<br /><b style={{ color: "#ffd904" }}>NOTRE ÉQUIPE !</b></h1>
                        <div className="imgCarrierebg">
                            <img className="imageBaniereCarriere" src={object_background} alt="" />
                        </div>
                 
                </div>
     </div>
    
     <div className="contactForm">
     
                    <div>
                        <h1 className="contactTitle">Postuler à travers ce Formulaire</h1>
                    </div>
                    
            <p style={{ color: "#636e72" ,fontSize:"15px",fontStyle:"italic"}} >Nous croyons que le grand acteur de la réussite d'une entreprise est la qualité de ses collaborateurs. Dans toute notre équipe, nous travaillons dur pour attirer, embaucher et former
              un personnel extraordinaire qui se distingue par sa convivialité, son manque d'intelligence, son éthique de travail, son empathie et sa conscience de soi. <br/><br/>
              
             <p style={{ color: "#0984e3" ,fontSize:"15px",fontStyle:"italic", marginLeft:"15px"}}> Que vous choisissiez de postuler ou de laisser vos informations, nous nous réjouissons de rester en contact avec vous.</p>
              </p>
                  <NotificationAlert ref="notificationAlert" />

                    <Grid fluid style={{ width: "60%", marginLeft: "auto" ,  marginRight: "auto"}} >
                    <Form onSubmit={this.onSubmit}>
                        <Row >
                        <Col xs={12} md={6} lg={12} style={{maxWidth: "100%"}}>
                            <Label style={{marginTop:"60px",color:"#636e72"}}>Post:</Label>
                              <TextField
                                required
                                margin="normal"
                                style={{width: "100%"}}
                                disabled
                               value={this.state.POst}
                                 
                                />
                        </Col> 
                        <Col xs={12} md={6} lg={6} style={{maxWidth: "100%"}}>
                            <TextField
                                required
                                label="Nom"
                                margin="normal"
                                style={{width: "100%"}}
                                value={this.state.lastname}
                                onChange={this.onChangeLastname}
                                />
                    
                        </Col> 
                        <Col xs={12} md={6} lg={6}  style={{maxWidth: "100%"}}> 
                                <TextField
                                label="Prénom"
                                required
                                style={{width: "100%"}}
                                margin="normal"
                                value={this.state.firstname}
                                onChange={this.onChangeFirstname}
                                />
                                
                        </Col>
                        <Col xs={12} md={6} lg={6} style={{maxWidth: "100%"}}>
                                <TextField
                                label="Email"
                                required
                                style={{width: "100%"}}
                                type="email"
                                autoComplete="email"
                                margin="normal"
                                value={this.state.email}
                                onChange={this.onchangeEmail}
                                />
                        </Col>
                            <Col xs={12} md={6} lg={6} style={{maxWidth: "100%"}}> 
                                <TextField
                                laxs={12} md={6} lg={12} style={{maxWidth: "100%"}} label="Numéro Du Telephone"
                                required
                                style={{width: "100%"}}
                                margin="normal"
                                value={this.state.number}
                                onChange={this.onChangeNumber}
                                />
                                 </Col>
                                 <Col xs={12} md={6} lg={12} style={{maxWidth: "100%"}}>
                                 <Label style={{color:"#636e72" ,paddingTop:"5px"}} >Inserér Votre Cv*</Label>
                                 <Label style={{color:"#b2bec3"}}>(2Mb Max size/seulement PDF,DOC,DOCX type accepter)</Label>
                                 <TextField 
                                 required
                                style={{width: "100%",marginBottom:"12px"}}
                                margin="normal"
                                type="file"
                                value={this.state.Cv}
                                onChange={(event) => {this.onchangeCV(event);}}
                                />
                                
                                </Col>
                           

                            
                           
                           
                        <Col xs={12} md={6} lg={6} style={{maxWidth: "100%"}}>

                       

                         </Col>
                        
                        </Row>
                        
                        <Button variant="contained" type="submit" style={{ backgroundColor: "#ffd904", boxShadow: "unset",marginLeft:"300px" }}
                       
                        >
                            Postuler
                        </Button>
                   
                        </Form>
                        <p style={{color:"#636e72"}}>Bon Chance !</p>
                    </Grid>
                    {this.state.show && <Msg/>}
                   
                </div>
      
                <MapAddresse />
                <NewsLetter />
                <Footer />
            </div>
      
    );
  }
}
class Msg extends React.Component {
  render(){
    return(

<UncontrolledAlert style={{ color: "#a6c19a", backgroundColor:"#2c38b5" , width:"450px", height:"50px", paddingTop:"15px", paddingLeft:"50px",marginLeft:"900px", marginTop:"30px"}}  >
 <span>
     Your Postulation has been send successfully 
     </span>
</UncontrolledAlert>
    )}
}
export default PostulateFormIntern;



// WEBPACK FOOTER //
// ./src/pages/FormPostulerInternship.js